import React from "react";
import { WithFieldValue, DocumentData } from "firebase/firestore";
import { Alert, Text } from "@chakra-ui/react";

import { PRODUCTION_STEPS_AUX } from "@constants";
import { useCustomToast, useStoreTags } from "@hooks";

import {
  JsonForm,
  JsonFormControl,
  makeCommentsControl,
  makeSelectControl,
} from "../JsonForm";
import { ButtonModal } from "../ModalWrappers";
import { useAddAuxStep } from "./useAddAuxStep";

type AddTagModalProps = {
  itemId: string;
};

function makeTagControl(tags: string[]) {
  return [
    makeSelectControl("Tag", "tag", tags, "Please select an appropriate tag."),
    makeCommentsControl(),
  ] as JsonFormControl[];
}

export function AddTagModal({ itemId }: AddTagModalProps) {
  const tags = useStoreTags();
  const tagFormControl = React.useMemo(() => makeTagControl(tags), [tags]);
  const addTagToast = useCustomToast(() => (
    <Alert status="success">Tag Added!</Alert>
  ));
  const [error, setError] = React.useState("");
  const addStep = useAddAuxStep(
    itemId,
    PRODUCTION_STEPS_AUX.STEP_AUX_TAG,
    addTagToast,
    setError,
  );
  const doSubmit = React.useCallback(
    async function <T extends WithFieldValue<DocumentData>>(data: T) {
      const comments = data.comments ? (data.comments as string) : "";
      const tag = data.tag ? (data.tag as string) : "";
      if (tag) addStep(comments, { tag });
      else setError("Select a tag");
    },
    [addStep],
  );

  return (
    <ButtonModal label="Add Tag" title="Add Tag" size="sm">
      <JsonForm fields={tagFormControl} onSubmit={doSubmit} clearAfterSubmit />
      {error ? <Text>{error}</Text> : undefined}
    </ButtonModal>
  );
}
